let logoutPeriodElement
let inactivityLimit
let inactivityTimer

function resetInactivityTimer() {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    document.getElementById('logout_button').click()
  }, inactivityLimit);
}

export function setAutoLogout() {
  if (document.getElementById('NAULOG') == null) { // pas d'auto logout, ex. formulaire de login
    logoutPeriodElement = document.getElementById('LOGOUT_PERIOD')
    inactivityLimit = parseInt(logoutPeriodElement.getAttribute('data-value')) * 60 * 1000

    document.addEventListener('mousemove', resetInactivityTimer);
    document.addEventListener('keydown', resetInactivityTimer);
    document.addEventListener('click', resetInactivityTimer);
    document.addEventListener('touchstart', resetInactivityTimer);
    resetInactivityTimer();
  }
}